module.exports = __webpack_public_path__ + "img/15passenger_parked.b2ea6141.svg";